/* eslint @typescript-eslint/default-param-last: 0 */
import styled from '@emotion/styled';
import { Accordion } from '@mui/material';

export const AccordionStyled = styled(Accordion)`
  border: ${({ theme }) => `1px solid ${theme.colors.neutral.shades.shade200}`};
  border-radius: 8px;
  box-shadow: none;
  margin-bottom: 20px;
  padding: 18px;
  .MuiPaper-root:before {
    background-color: transparent;
  }
    &:before {
    background-color: transparent;
  }
`;
